import { CustomerFileCategory } from '../graphql/generated';

export const PRE_QUALIFICATION_DATA = 'PRE_QUALIFICATION_DATA';
export const REQUITY_HOMES_INFO_EMAIL = 'info@requityhomes.com';
export const REQUITY_HOMES_CONTACT_NUMBER = '1-855-952-6492';
export interface FileWithCategory {
  file: File;
  category: CustomerFileCategory;
}

export const HAS_SEEN_ALL_PAGES = 'HAS_SEEN_ALL_PAGES';

export const MAXIMUM_MONTHLY_DEBT_PAYMENT = 5000;

export const REFERRAL_CODE = '_referralCode';

export const COOKIE_UTM_KEY = '_cookie_utm_key';

export enum ApplicantType {
  PRIMARY_APPLICANT = 'PRIMARY_APPLICANT',
  CO_APPLICANT = 'CO_APPLICANT',
}

export const HOME_SHOPPING_FAQs = {
  offerProcess: {
    step1: 'Inform your realtor of your interest to make an offer on a home.',
    step2:
      "We'll let you know if the home meets our criteria and send an e-signature request for a commitment letter and banking info to submit the $500 application fee.",
    step3:
      "Afterwards, we'll email you a draft offer with important details (e.g. closing date, price, conditions, deposits, etc.) for your approval before sending it to the listing agent or the seller.",
    step4:
      "Once we have your consent, we'll forward the offer to the listing agent/seller and wait for a response, which can take 24-48 hours, and may involve further negotiations.",
  },
  redFlags: {
    _1: 'Sold as is',
    _2: 'Fix-upper',
    _3: 'Handyman special',
    _4: 'TLC required',
    _5: 'Not habitable',
    _6: 'Home has no interior photos',
  },
};
